// Day/night switch for the header. The current theme lives on
// <html data-theme>, set before first paint by the script in
// public/index.html; CSS shows the moon in light mode and the sun in dark.
export const ThemeToggle = () => {
  const toggle = () => {
    const next = document.documentElement.dataset.theme === "dark" ? "light" : "dark";
    if (window.setTheme) {
      window.setTheme(next);
    } else {
      document.documentElement.dataset.theme = next;
    }
  };

  return (
    <button type="button" className="theme-toggle" onClick={toggle} aria-label="Switch between light and dark theme" title="Switch theme">
      {/* Moon: shown in light mode */}
      <svg className="theme-toggle-night" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" />
      </svg>
      {/* Sun: shown in dark mode */}
      <svg className="theme-toggle-day" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
      </svg>
    </button>
  );
};
